// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#2B5FF5","mdBreak":"1024px","list":"e9pXKhzuhAFV4jkG3_ko","vertical":"Vk6EdakBXUsdVGYCIMWT","selected":"htzJVRQXUw8FVUXOSgl0"};